import React, { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { DateTime } from 'luxon';
import "venobox/dist/venobox.min.css";

// import SplitData from "../../data/elements/split.json";

const PastEvent = ({ events }) => {
  useEffect(() => {
    import("venobox/dist/venobox.min.js").then((venobox) => {
      new venobox.default({
        selector: ".popup-video",
      });
    });
  }, []);

  const playIcon = "/images/icons/youtube.png"

  return (
    <>
      <br /><br />
      <h2>Past Events</h2>
      {events &&
        events.map((data, index) => (
          <div className="row g-5 align-items-center" key={index}>
            <hr />
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="inner pr--50 pr_md--0 pr_sm--0">
                <div className="section-title text-start">
                  {/* <span className="subtitle bg-primary-opacity">
                    {DateTime.fromISO(data.date.start).toFormat("MMM, yyyy")}
                  </span> */}
                  <h3 className="title">{DateTime.fromISO(data.date.start).toFormat("MMMM, yyyy")}</h3>
                  <span className="rbt-badge bg-secondary-opacity mt--10">
                    {data.location.name}
                  </span>
                  {/* <h3 className="title">{data.title}</h3>
                  <br />
                  <span className="rbt-badge-6 bg-secondary-opacity">
                    {DateTime.fromISO(data.date.start).toFormat("d MMM, yyyy")}
                  </span> */}
                  <p className="description mt--10">
                    {data.recap.summary}
                  </p>
                  <div className="read-more-btn">
                    <a className="rbt-moderbt-btn" href={data.external_url} target="_blank">
                      <span className="moderbt-btn-text">
                        Explore
                      </span>
                      <i className="feather-arrow-right"></i>
                    </a>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            {(data.recap && data.recap.video_url) ? (
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="video-popup-wrapper">
                  <Image
                    className="w-100 rbt-radius"
                    src={data.recap.video_thumbnail}
                    width={590}
                    height={424}
                    alt="Video Images"
                  />
                  <Link
                    className="popup-video position-to-top"
                    data-vbtype="video"
                    href={data.recap.video_url}
                  >
                    <span>
                      <Image
                        src={playIcon}
                        width={100}
                        height={70}
                        alt=""
                      />
                    </span>
                  </Link>
                </div>
              </div>
            ) : (
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="video-popup-wrapper">
                  <Image
                    className="w-100 rbt-radius"
                    src={data.image.thumbnail}
                    width={638}
                    height={458}
                    alt="Video Images"
                  />
                </div>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default PastEvent;
